var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AnimationState } from 'components/transition/private/Animator';
import { Animator } from 'components/transition/private/Animator';
/**
 * @class TogetherAnimator
 * @since 1.0.0
 * @hidden
 */
export class TogetherAnimator extends Animator {
    /**
     * @inherited
     * @function insert
     * @since 1.0.0
     */
    insert(key, component, from) {
        this.presentAnimationState[key] = AnimationState.Awaits;
        this.present[key] = component;
        const processing = key in from.content;
        const presenting = key in from.present;
        const dismissing = key in from.dismiss;
        if (processing == false) {
            return;
        }
        if (presenting) {
            const state = from.presentAnimationState[key];
            if (state == AnimationState.Awaits || state == AnimationState.Active) {
                this.presentAnimationState[key] = state;
            }
        }
        if (dismissing) {
            const state = from.dismissAnimationState[key];
            if (state == AnimationState.Awaits || state == AnimationState.Active) {
                this.presentAnimationState[key] = state;
            }
        }
    }
    /**
     * @inherited
     * @function remove
     * @since 1.0.0
     */
    remove(key, component, from) {
        this.dismissAnimationState[key] = AnimationState.Awaits;
        this.dismiss[key] = component;
        const processing = key in from.content;
        const presenting = key in from.present;
        const dismissing = key in from.dismiss;
        if (processing == false) {
            return;
        }
        if (presenting) {
            const state = from.presentAnimationState[key];
            if (state == AnimationState.Awaits || state == AnimationState.Active) {
                this.dismissAnimationState[key] = state;
            }
        }
        if (dismissing) {
            const state = from.dismissAnimationState[key];
            if (state == AnimationState.Awaits || state == AnimationState.Active) {
                this.dismissAnimationState[key] = state;
            }
        }
    }
    /**
     * @inherited
     * @function update
     * @since 1.0.0
     */
    update(key, component, from) {
        this.content[key] = component;
    }
    /**
     * @inherited
     * @method start
     * @returns
     */
    play() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.dismissCount)
                this.prepareDismissItems();
            if (this.presentCount)
                this.preparePresentItems();
            yield this.waitForRender();
            yield Promise.all([this.dismissItems(), this.presentItems()]);
        });
    }
}
